// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"1a8b1cd9","787":"1e83dcc9"}[chunkId] + ".chunk.js";
};